import { render, staticRenderFns } from "./titleSection.vue?vue&type=template&id=f58df82c&scoped=true&"
import script from "./titleSection.vue?vue&type=script&lang=ts&"
export * from "./titleSection.vue?vue&type=script&lang=ts&"
import style0 from "./titleSection.scss?vue&type=style&index=0&id=f58df82c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f58df82c",
  null
  
)

export default component.exports